module.exports = __webpack_public_path__ + "img/download.8e60649c.svg";